import {useGetParticipationQuery} from '@dms/api/core';
import {useGetInterestV2Query} from '@dms/api/finance';
import {EntityResourceIds} from '@dms/api/shared';

import {usePermissions} from './usePermissions/usePermissions';

interface InterestEditPermissions {
  interestId: string;
}

export const useInterestEditPermissions = (props: InterestEditPermissions) => {
  const {data: interestParticipation} = useGetParticipationQuery({
    recordId: props.interestId,
    resourceId: EntityResourceIds.interest,
  });

  const {data: interestData} = useGetInterestV2Query({
    id: props.interestId,
  });

  const [
    hasChangeCustomerInterestPermission,
    hasSelectContactPersonInterestPermission,
    hasOpenInterestPermission,
    hasEndInterestPermission,
    hasReopenInterestPermission,
    hasChangeMinisalePriceOfferedInterestPermission,
    hasChangeLeadQualityInterestPermission,
    hasConvertToBusinessCaseInterestPermission,
    hasAddMinipurchaseOfferedVehicleInterestPermission,
    hasRemoveMinipurchaseOfferedVehicleInterestPermission,
  ] = usePermissions({
    permissionKeys: [
      'interestChangeCustomer',
      'interestSelectContactPerson',
      'interestOpen',
      'interestEnd',
      'interestReopen',
      'interestChangeMinisalePriceOffered',
      'interestChangeLeadQuality',
      'interestConvertToBusinessCase',
      'interestAddMinipurchaseOfferedVehicle',
      'interestRemoveMinipurchaseOfferedVehicle',
    ],
    scopes: {
      interestChangeCustomer: {
        participation: interestParticipation,
        branchId: interestData?.branchId,
      },
      interestSelectContactPerson: {
        participation: interestParticipation,
        branchId: interestData?.branchId,
      },
      interestOpen: {
        participation: interestParticipation,
        branchId: interestData?.branchId,
      },
      interestEnd: {
        participation: interestParticipation,
        branchId: interestData?.branchId,
      },
      interestReopen: {
        participation: interestParticipation,
        branchId: interestData?.branchId,
      },
      interestChangeMinisalePriceOffered: {
        participation: interestParticipation,
        branchId: interestData?.branchId,
      },
      interestChangeLeadQuality: {
        participation: interestParticipation,
        branchId: interestData?.branchId,
      },
      interestConvertToBusinessCase: {
        participation: interestParticipation,
        branchId: interestData?.branchId,
      },
      interestAddMinipurchaseOfferedVehicle: {
        participation: interestParticipation,
        branchId: interestData?.branchId,
      },
      interestRemoveMinipurchaseOfferedVehicle: {
        participation: interestParticipation,
        branchId: interestData?.branchId,
      },
    },
  });

  return {
    hasChangeCustomerInterestPermission,
    hasSelectContactPersonInterestPermission,
    hasOpenInterestPermission,
    hasEndInterestPermission,
    hasReopenInterestPermission,
    hasChangeMinisalePriceOfferedInterestPermission,
    hasChangeLeadQualityInterestPermission,
    hasConvertToBusinessCaseInterestPermission,
    hasAddMinipurchaseOfferedVehicleInterestPermission,
    hasRemoveMinipurchaseOfferedVehicleInterestPermission,
  };
};
